import * as React from "react";
import PropTypes from "prop-types";
import Button from "../buttons/Button";
import "./Toolbar.scss";
import { buildUrl } from "../utils/helper";
import flags from "../utils/flags";

/**
 * Detail toolbar component
 * @module
 * @param {bool} disabled - Is toolbar disabled?
 * @param {number} akcDisabled - Disabled actions mask number
 * @param {number} akcHidden - Hidden actions mask number
 * @param {element} children - Children
 * @param {string} primaryField - Primary field
 * @param {func} next - Switches to the next entry function
 * @param {func} previous - Switches to the previous entry function
 * @param {bool} disabledNext - Is next entry disabled?
 * @param {bool} disabledPrevious - Is previous entry disabled?
 * @param {element} currentEl - Current element
 * @param {func} onGet - Get item function
 * @param {func} onBack - Function invoked after click on back arrow
 * @param {bool} hiddenBack - Hidden back arrow in detail toolbar
 * @param {bool} hiddenSave - Hidden save button in detail toolbar
 * @param {bool} hiddenPrint - Hidden print button in detail toolbar
 * @param {bool} onPrint - Function invoked after click on print button
 * @param {bool} withMeta - With meta
 */
const ToolbarComponent = (props) => {
  const handleBack = () => {
    props.onBack();
  };

  const handleSaveNew = async (event) => {
    if (await props.onSubmit(event)) {
      await props.onGet(0);
    }
  };

  const handleSaveback = async (event) => {
    if (await props.onSubmit(event)) {
      props.onBack(event);
    }
  };

  const defFormNoMeta =
    !props.withMeta &&
    props.akcHidden === undefined &&
    props.akcDisabled === undefined;
  return (
    <div id="detail-toolbar" className="toolbar">
      <span className="left">
        {!props.hiddenBack && (
          <Button
            onClick={handleBack}
            primary={true}
            imageUrl={buildUrl("assets/icons/spät.svg")}
            title="Späť"
            className="button-back"
          />
        )}
        {!props.hiddenSave && !(props.akcHidden & flags.SAVE) && (
          <Button
            onClick={props.onSubmit}
            primary={true}
            disabled={
              (!props.withMeta && props.disabled) ||
              props.akcDisabled & flags.SAVE
            }
            title="Uložiť"
            className="button-save"
            imageUrl={buildUrl("assets/icons/toolbar_save.svg")}
          />
        )}
        {!defFormNoMeta &&
          !props.hiddenSave &&
          !(props.akcHidden & flags.SAVE_NEW) && (
            <Button
              onClick={handleSaveNew}
              primary={true}
              disabled={props.akcDisabled & flags.SAVE_NEW}
              title="Uložiť a vytvoriť nový záznam"
              className="button-save"
              imageUrl={buildUrl("assets/icons/toolbar_save_and_new.svg")}
            />
          )}
        {!defFormNoMeta &&
          !props.hiddenSave &&
          !(props.akcHidden & flags.SAVE_BACK) && (
            <Button
              onClick={handleSaveback}
              primary={true}
              disabled={props.akcDisabled & flags.SAVE_BACK}
              title="Uložiť a späť na zoznam"
              className="button-save"
              imageUrl={buildUrl("assets/icons/toolbar_save_and_back.svg")}
            />
          )}
        {props.children && props.children.length !== 0 && <span className='delimeter'></span>}
        {props.children}
      </span>

      <span className="right">
        {props.currentEl}
        <span className="arrowsButtons">
          <Button
            onClick={props.previous}
            primary={true}
            imageUrl={buildUrl("assets/icons/sipka_vlavo.svg")}
            title="Predchádzajúci záznam"
            disabled={props.disabledPrevious}
          />
          <Button
            onClick={props.next}
            primary={true}
            imageUrl={buildUrl("assets/icons/sipka_vpravo.svg")}
            title="Ďalší záznam"
            disabled={props.disabledNext}
          />
        </span>
      </span>
    </div>
  );
};

ToolbarComponent.propTypes = {
  disabled: PropTypes.bool,
  akcDisabled: PropTypes.number,
  akcHidden: PropTypes.number,
  children: PropTypes.any,
  primaryField: PropTypes.string.isRequired,
  next: PropTypes.func.isRequired,
  previous: PropTypes.func.isRequired,
  disabledPrevious: PropTypes.bool,
  disabledNext: PropTypes.bool,
  currentEl: PropTypes.element,
  onBack: PropTypes.func.isRequired,
  onGet: PropTypes.func,
  hiddenBack: PropTypes.bool,
  hiddenSave: PropTypes.bool,
  withMeta: PropTypes.bool,
};

export default ToolbarComponent;
